import { queryKeys } from '../../queries/queryKeys';
import { post } from '../../queries';
import { useApiMutation } from '../../queries/useApiMutation';

export const useResetPasswordWithTokenMutation = () => {
    const mutation = useApiMutation<{ email: string; resetToken: string; newPassword: string }>({
        invalidateQueryOnMutate: true,
        queryKey: queryKeys.auth(),
        mutationFn: ({ email, resetToken, newPassword }) =>
            post(`identity/resetPasswordWithToken`, { email: email, resetToken: resetToken, password: newPassword }),
    });

    return { ...mutation };
};
